/**
 * Role badges. Served art (see ./art.ts), downloaded with the room's asset
 * package. Exhaustive over each game's role type: a new role without an icon
 * does not compile.
 */
import { artUrl } from './art';
/** Hide and Seek: hider / seeker badges. */
export const HNS_ROLE_ICONS = {
    hider: 'hns/roles/hider.png',
    seeker: 'hns/roles/seeker.png',
};
export function getHnsRoleIconUrl(role) {
    return artUrl(HNS_ROLE_ICONS[role]);
}
/** FP Race: the registration roles (tank / healer / DPS). */
export const FPR_ROLE_ICONS = {
    tank: 'fpr/roles/tank.png',
    healer: 'fpr/roles/heal.png',
    dps: 'fpr/roles/dps.png',
};
export function getFprRoleIconUrl(role) {
    return artUrl(FPR_ROLE_ICONS[role]);
}
